import { MouseEvent, useState } from 'react'

interface Menu {
  /**
   * The anchor element.
   */
  anchorEl?: HTMLElement

  /**
   * Indicates if the menu is open.
   */
  open: boolean

  /**
   * The alias for `open`.
   */
  isMenuOpen: boolean

  /**
   * Open the menu.
   */
  openMenu: (event: MouseEvent<HTMLElement>) => void

  /**
   * Close the menu.
   */
  closeMenu: () => void
}

export default function useMenu(): Menu {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>()

  const isMenuOpen = Boolean(anchorEl)

  const openMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const closeMenu = () => {
    setAnchorEl(undefined)
  }

  return { anchorEl, open: isMenuOpen, isMenuOpen, openMenu, closeMenu }
}
